import { Col, Container } from "react-bootstrap";
import { Droplet, ClockHistory, Stars, ShieldCheck } from "react-bootstrap-icons";
import SectionHeading from "../ui/SectionHeading";
import { RevealGroup, RevealItem } from "../ui/Reveal";
import "../style/WhyChooseUs.css";

const PILLARS = [
  {
    icon: Droplet,
    title: "Fresh, not frozen",
    text: "Preservative-free batter that makes home cooking easier and healthier.",
  },
  {
    icon: ClockHistory,
    title: "The old way, still",
    text: "Stone-ground slowly, the traditional way — for the texture and taste you grew up with.",
  },
  {
    icon: Stars,
    title: "Always improving",
    text: "We keep adding to the family of batters without ever cutting corners on quality.",
  },
  {
    icon: ShieldCheck,
    title: "Clean, sealed, safe",
    text: "Packed in food-grade, ziplock-sealed pouches for freshness in every pack.",
  },
];

const WhyChooseUs = () => {
  return (
    <section className="section-pad why-choose">
      <Container className="container-narrow">
        <SectionHeading
          eyebrow="Why Fresh Matters"
          title="No Shortcuts, Just Good Batter"
          subtitle="Everything we promise on the packet, we mean at the kitchen table."
        />
        <RevealGroup className="row g-4">
          {PILLARS.map(({ icon: Icon, title, text }, i) => (
            <Col sm={6} lg={3} key={title} className="d-flex">
              <RevealItem delay={i * 80} className="why-choose__card card-surface">
                <Icon size={26} className="why-choose__icon" />
                <h3>{title}</h3>
                <p>{text}</p>
              </RevealItem>
            </Col>
          ))}
        </RevealGroup>
      </Container>
    </section>
  );
};

export default WhyChooseUs;
